import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { Header } from '@/components/modules/Header';
import { CONSTANTS } from '@/constants';

// Types
interface IProps {}

const SubscriptionTerms: React.FC<IProps> = () => {
	const router = useRouter();

	return (
		<section className='static-page'>
			<Header
				showMenuButton
				showCenterLogo
				action={{
					icon: 'back',
					goBackCallback: () => router.back(),
				}}
			/>
			<div className='container old-styles'>
				<h1>Subscription Terms</h1>
				<h2>1. Trial</h2>
				<p>
					We may offer a trial subscription for service. Unless you cancel
					before the end of the trial, you will be automatically charged a price
					indicated on the payment screen for a chosen subscription period.
				</p>
				<h2>2. Subscription</h2>
				<p>
					The subscription renews automatically at the end of each period (each
					week, month, 6 months, year, or otherwise) until you cancel.
				</p>
				<h2>3. Payment method</h2>
				<p>
					Payment will be charged to the payment method you submitted at the
					time of purchase at confirmation of purchase. You authorize us to
					charge the applicable fees to the payment method that you submit.
				</p>
				<h2>4. Cancellation</h2>
				<p>
					Cancelling your subscription means that the automatic renewal will be
					disabled, but you will still have access to all your subscription
					features for the remaining time of then-current period. Note that
					deleting the app does not cancel your subscriptions.
				</p>
				<p>
					If you purchased a subscription or enabled trial on App Store: You can
					cancel a trial or a subscription anytime by turning-off autorenewal
					through your Apple ID account settings. To avoid being charged, cancel
					the subscription in your Apple ID account settings before the end of
					the trial or then-current subscription period. You alone can manage
					your subscriptions. Learn more about managing subscriptions (and how
					to cancel them) on{' '}
					<a href='https://support.apple.com/en-us/118428'>
						Apple support page
					</a>
					.
				</p>
				<p>
					If you purchased a subscription or enabled trial on Google Play: You
					can cancel a trial or a subscription anytime by turning off
					auto-renewal through your Google Play account settings. To avoid being
					charged, cancel the subscription in your account settings before the
					end of the trial or then-current subscription period. You alone can
					manage your subscriptions. Learn more about managing subscriptions
					(and how to cancel them) on{' '}
					<a href='https://support.google.com/googleplay/workflow/9827184?hl=en'>
						Google’s support page
					</a>
					.
				</p>
				<p>
					If you purchased a subscription or enabled trial on our website
					liftapp.ai you can cancel a trial or a subscription by the link{' '}
					<a href='https://liftapp.ai/editor/cancel-subscription/subscription-list'>
						https://liftapp.ai/editor/cancel-subscription/subscription-list
					</a>{' '}
					or visit the subscription settings in Lift app.
				</p>
				<h2>5. Changes</h2>
				<p>
					To the maximum extent permitted by applicable laws, we may change
					subscription fees at any time. We will give you reasonable notice of
					any such pricing changes by posting the new prices on the app and/or
					by sending you an email notification, or in other prominent way. If
					you do not wish to pay the new fees, you can cancel the applicable
					subscription prior to the change going into effect.
				</p>
				<h2>6. Refunds</h2>
				<p>
					If you purchased a subscription or enabled trial on App Store: If you
					are eligible for a refund, you’ll have to request it directly from
					Apple. To request a refund, follow these instructions from the{' '}
					<a href='https://support.apple.com/en-us/118428'>
						Apple support page
					</a>
					.
				</p>
				<p>
					If you purchased a subscription or enabled trial on Google Play: If
					you are eligible for a refund, you'll have to request it directly from
					Google. To request a refund, follow these instructions from the{' '}
					<a href='https://support.google.com/googleplay/workflow/9827184?hl=en'>
						Google’s support page
					</a>
					.
				</p>
				<p>
					If you purchased a subscription or enabled trial on our website:
					Please refer to our{' '}
					<Link href='/terms-of-use' prefetch={false}>
						Terms of Use
					</Link>
					.
				</p>
				<h2>7. Contacts</h2>
				<p>
					If you have any questions in relation to the subscription terms,
					please contact us at{' '}
					<a href={`mailto:${CONSTANTS.SUPPORT_MAIL_ADDRESS}`}>
						{CONSTANTS.SUPPORT_MAIL_ADDRESS}
					</a>
					.
				</p>
				<p>
					Please make a screenshot of this information for your reference. This
					may help you to control your subscriptions.
				</p>
			</div>
		</section>
	);
};

export default SubscriptionTerms;
